import React, { useEffect } from 'react'
import Event11 from './eventImg/event-13-june.webp'


const Event12 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge Talk on HVAC Hydronics System Design Optimization";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>11 June 2025</h1> 
<h3 className='text-center'>ISHRAE Knowledge Talk on HVAC Hydronics System Design Optimization</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event11} alt='ISHRAE Knowledge Talk on HVAC Hydronics System Design Optimization'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/NVzIV4MavwU=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event12

